import { ReactNode, useEffect, useState } from "react";
import "../../../../assets/css/filtro-generico.min.css";
import CloseIcon from "@mui/icons-material/Close";

/**
 * Una opcion del filtro. Puede ser texto suelto --como lo usaban los 22
 * llamadores que ya existian, y se sigue comportando igual-- o un par
 * etiqueta/valor, para cuando lo que se muestra no es lo que se manda.
 *
 * Hizo falta por el filtro de cedula: en pantalla dice "Datos coinciden",
 * pero el backend espera el veredicto del motor ("validado"). Antes de esto
 * la unica salida era mostrar "requiere_recaptura" tal cual en un boton.
 */
type OpcionFiltro = string | { etiqueta: string; valor: string };

/**
 * Marca o desmarca un valor en la lista de un filtro.
 *
 * Esta afuera del componente porque es logica pura y porque aca vivio un
 * error que llego al usuario: la lista puede NO EXISTIR. Pasa cada vez que se
 * agrega una opcion nueva -- quien ya habia usado los filtros tiene un objeto
 * guardado sin esa clave, y `undefined.includes` rompe la pantalla entera.
 *
 * Devuelve un arreglo nuevo en vez de mutar el del estado, que es lo que hacia
 * antes con push y splice.
 */
export function alternarValor(lista: unknown, valor: string): string[] {
  const actual: string[] = Array.isArray(lista) ? (lista as string[]) : [];
  return actual.includes(valor)
    ? actual.filter((x) => x !== valor)
    : [...actual, valor];
}

/** `true` si el valor ya viene marcado desde lo guardado en localStorage. */
export function yaEstaGuardado(guardado: unknown, clave: string, valor: string): boolean {
  const lista = (guardado as Record<string, unknown> | null | undefined)?.[clave];
  return Array.isArray(lista) && lista.includes(valor);
}

interface IStateFilter {
  layer: string;
  listState: OpcionFiltro[] | any;
  localStorageFilter: string;
  onValueChange?: Function;
  onPropertyChange?: string | any;
  onPermaValues?: any;
}

export default (props: IStateFilter) => {
  const {
    layer,
    listState,
    localStorageFilter,
    onValueChange,
    onPropertyChange,
    onPermaValues,
  } = props;

  const [currenFilterStorage, setCurrentFilterStorage] = useState<any>();

  // El valor es lo que viaja al backend; la etiqueta, lo que se ve. Para un
  // item de texto son la misma cosa, que es como se comportaba hasta ahora.
  const valorDe = (item: OpcionFiltro): string =>
    typeof item === "string" ? item : item.valor;
  const etiquetaDe = (item: OpcionFiltro): string =>
    typeof item === "string" ? item : item.etiqueta;

  useEffect(() => {
    if (localStorage.getItem(localStorageFilter)) {
      const copyStorage: any = localStorage.getItem(localStorageFilter);
      setCurrentFilterStorage(JSON.parse(copyStorage));
    }
  }, [localStorage.getItem(localStorageFilter)]);

  const handleEventSetFormFilter = (item: any) => {
    /**
     * El filtro guardado en localStorage puede NO tener esta clave.
     *
     * Pasa siempre que se agrega una opcion nueva: quien ya habia usado los
     * filtros tiene un objeto viejo, sin la clave, y `undefined.includes`
     * rompe la pantalla entera. No es propio del filtro de cedula -- le
     * habria pasado igual a cualquier opcion que se agregue mas adelante.
     */
    if (yaEstaGuardado(currenFilterStorage, onPermaValues, item)) {
      return;
    }
    if (onPermaValues && onPropertyChange && onValueChange) {
      onValueChange({
        ...onPropertyChange,
        [onPermaValues]: alternarValor(onPropertyChange[onPermaValues], item),
      });
    }
  };

  return (
    <>
      <div className="section-filter">
        <span className="title">{layer}</span>
        <section className="section-button">
          {listState && onPropertyChange && onPermaValues && listState.map((item: OpcionFiltro) => {
            const valor = valorDe(item);
            return onPropertyChange[onPermaValues]?.includes(valor) ? (
              <button
                key={valor}
                onClick={() => handleEventSetFormFilter(valor)}
                className={`button-filter active`}
              >
                {etiquetaDe(item)}
                <CloseIcon />
              </button>
            ) : (
              <button
                key={valor}
                onClick={() => handleEventSetFormFilter(valor)}
                className={`button-filter`}
              >
                {etiquetaDe(item)}
              </button>
            );
          })}
        </section>
      </div>
    </>
  );
};
